import lambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';
import { setUserLocale } from 'APP_ROOT/localization';

// {"facialRecognition":{"enabled":true},"general":{"unitOfMeasure":"IMPERIAL"}}

// Returns if a value is an object
function isObject (value) {
    return value && typeof value === 'object' && value.constructor === Object;
}

// flatten takes a nested object and flattens it, preserving the structure information in prefixed property names
// E.g. { "name": { "first": "jeff", "last": "washer" } } becomes { "name.first": "jeff", "name.last": "washer" }
const SEPARATOR = '.';
export function flatten(val, prefix = '', collector = {}) {
    if (!isObject(val)) {
        return val;
    }
    // TODO: make sure this isn't a vulnerability (like the _.merge thing)
    for(const x in val) {
        const key = prefix ? prefix + SEPARATOR + x : x;
        const valx = val[x];
        if(isObject(valx)) {
            // recursive call
            flatten(valx, key, collector);
        } else {
            collector[key] = valx;
        }
    }
    return collector;
}

export function unflatten(key, value) {
    return key.split(SEPARATOR)
        .reverse()
        .reduce((acc, it, index)=>{
            return { [it]: acc };
        }, value);
}

export function fetchSettings(stage) {
    return lambdaUtil.getSettings(stage)
        .then(response => {
            return flatten(response.payload);
        }).catch(err => {
            // report the error and then turn it into something that can be shown to the user
            console.log('data/settings/api fetchSettings', err);
            throw new Error('An error occurred fetching account settings.');
        });
}

export function updateSettings(stage, settings) {
    return lambdaUtil.updateSettings(stage, settings)
        .then(response => {
            if (settings && settings.user && settings.user.general && settings.user.general.locale) {
                setUserLocale(settings.user.general.locale);
            }
            return flatten(response.payload);
        }).catch(err => {
            // report the error and then turn it into something that can be shown to the user
            console.log('data/settings/api updateSettings', err);
            throw new Error('An error occurred updating account settings.');
        });
}

export function updateSettingValue(stage, key, value) {
    return updateSettings(stage, unflatten(key, value));
}
